import {
	InformationPopupButtonContainer,
	InformationPopupButton,
	PromotionPopupCloseButton,
	SingleInputFormPopupSubmitButton,
} from './Button';

import {
	InformationPopupContainer,
	PromotionPopupImg,
	SingleInputFormPopupContainer,
} from './Popup';
import {
	InformationPopupTextContainer,
	InformationPopupTitle,
	InformationPopupSubText,
	InformationPopupWarning,
	SingleInputFormPopupTitle,
	SingleInputFormPopupErrorMessage,
	SingleInputFormPopupTextHeader,
} from './Text';

export const InformationPopup = {
	Container: InformationPopupContainer,
	ButtonContainer: InformationPopupButtonContainer,
	Button: InformationPopupButton,

	TextContainer: InformationPopupTextContainer,
	Title: InformationPopupTitle,
	SubText: InformationPopupSubText,
	Warning: InformationPopupWarning,
};

export const PromotionPopup = {
	Container: InformationPopupContainer,
	ButtonContainer: InformationPopupButtonContainer,
	Button: InformationPopupButton,
	Img: PromotionPopupImg,
	CloseIcon: PromotionPopupCloseButton,

	TextContainer: InformationPopupTextContainer,
	Title: InformationPopupTitle,
	SubText: InformationPopupSubText,
	Warning: InformationPopupWarning,
};

export const SingleInputFormPopup = {
	Container: SingleInputFormPopupContainer,
	TextContainer: SingleInputFormPopupTextHeader,
	Title: SingleInputFormPopupTitle,
	ErrorMessage: SingleInputFormPopupErrorMessage,
	Button: SingleInputFormPopupSubmitButton,
};
